import classNames from 'classnames';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import * as styles from './index.css';

export type TextButtonVariant = 'primary' | 'danger';

const variantStyles: Record<TextButtonVariant, string> = {
    primary: styles.btnPrimary,
    danger: styles.btnDanger,
};

type TextButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    variant?: TextButtonVariant;
    underline?: boolean;
    children: ReactNode;
};

export function TextButton({
    variant = 'primary',
    type = 'button',
    className,
    children,
    underline = false,
    ...props
}: TextButtonProps) {
    return (
        <button
            type={type}
            className={classNames(variantStyles[variant], { [styles.underline]: underline }, className)}
            {...props}
        >
            {children}
        </button>
    );
}
